import * as actionTypes from "~/store/action_types";
import Angie from "~/utils/angie.jsx";
import { fetch } from "~/utils/fetch.jsx";

export const fetchAccountSettings = () => {
  return {
    types: [
      actionTypes.FETCH_ACCOUNT_SETTINGS_LOADING,
      actionTypes.FETCH_ACCOUNT_SETTINGS_SUCCESS,
      actionTypes.FETCH_ACCOUNT_SETTINGS_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/account-settings`,
      }),
  };
};

export const fetchAccountUsedStorage = () => {
  return {
    types: [
      actionTypes.FETCH_ACCOUNT_USED_STORAGE_LOADING,
      actionTypes.FETCH_ACCOUNT_USED_STORAGE_SUCCESS,
      actionTypes.FETCH_ACCOUNT_USED_STORAGE_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/on-demand/current-usage`,
      }),
  };
};
